<div class="registration-account-type">
    <div class="account-type--section">
        <div class="account-type-heading">
            <div class="registration--bullet-point" tabindex="0">
                {{ state.registrationPage.accountType.stepNumber }}
            </div>
            <h2 tabindex="0">{{ state.registrationPage.accountType.heading }}</h2>
        </div>
    </div>
    <div class="account-type--form-check">
        <mat-radio-group class="account-type-radio" aria-label="Select an option">
          <mat-radio-button value="businessAccount" (change)="onOptionChange('BUSINESS_ADMIN_USER')"
          [checked]="selectedRadioOption !=='INDIVIDUAL_USER'">
                  {{ state.registrationPage.accountType.businessAccount.label }}
                  <span class="highlight">{{ state.registrationPage.accountType.businessAccount.tokenData[0].text }}</span>
              <div class="mobileView">
                  <p class="business-account-description">{{ state.registrationPage.accountType.businessAccount.description1 }}</p>
              </div>
              <div class="desktopView">
                  <p class="business-account-description">{{ state.registrationPage.accountType.businessAccount.description1 }}</p>
              </div>
          </mat-radio-button>
          <mat-radio-button value="individualAccount" (change)="onOptionChange('INDIVIDUAL_USER')"
            [checked]="selectedRadioOption==='INDIVIDUAL_USER'">
                  {{ state.registrationPage.accountType.individualAccount.label }}
                  <span class="highlight">{{ state.registrationPage.accountType.individualAccount.tokenData[0].text }}</span>
              <div class="mobileView">
                  <p class="individual-account-description1">{{ state.registrationPage.accountType.individualAccount.description1 }}</p>
                  <p class="individual-account-description2">{{ state.registrationPage.accountType.individualAccount.description2}}</p>
              </div>
              <div class="desktopView">
                  <p class="individual-account-description1">{{ state.registrationPage.accountType.individualAccount.description1 }}</p>
                  <p class="individual-account-description2">{{ state.registrationPage.accountType.individualAccount.description2}}</p>
              </div>
          </mat-radio-button>
        </mat-radio-group>
  </div>
</div>
